import React, { useEffect, useRef, useState } from "react";
import "./PersonalDetails.css";
import "../../../main.css";
import Typography from "antd/es/typography/Typography";
import {
  Avatar,
  Button,
  Checkbox,
  Col,
  Form,
  Image,
  message,
  Modal,
  Radio,
  Row,
  Spin,
  Switch,
  DatePicker,
} from "../../common/utils/antd-imports/AntdImports";
import { EditOutlined, UploadOutlined } from "@ant-design/icons";
import { ReactComponent as AccountTypeIcon } from "../../../assests/AccountTypeIcon.svg";
import DefaulImage from "../../../assests/default-Image.jpg";
import { API_BASE_URL_IMAGE } from "../../../services/common";
import { ReactComponent as BackButton } from "../../../assests/back-arrow.svg";
import { ReactComponent as RightArrow } from "../../../assests/right-arrow.svg";
import { ReactComponent as Speaker } from "../../../assests/speaker.svg";
import {
  deleteUserProfile,
  getUserProfile,
  postUserProfile,
  varibaleChargeRate,
} from "../../../store/thunks/common-thunks/commonThunk";
import { useDispatch, useSelector } from "react-redux";
import FloatingInput from "../float-input/FloatInput";
import { format } from "date-fns";
import moment from "moment-timezone";
import { useLocation, useNavigate } from "react-router-dom";
import { logout } from "../../../store/slices/auth/LoginSlice";
import { RESET_USER } from "../../../store/slices/auth/UserProfileSlice";
import enUS from "antd/es/date-picker/locale/en_US";
import { clearAllFilters as clearAllProductFilters } from "../../../store/slices/common-slice/product-filters/ProductFilter";
import ChangePassword from "../../modal/change-password-modal/ChangePassword";
import { ReactComponent as CalenderIcon } from "../../../assests/Billboard_Calender_Icon.svg";
import dayjs from "dayjs";

const { Text } = Typography;
const PersonalDetails = () => {
  const [file, setFile] = useState();
  const [binaryImage, setBinaryImage] = useState();
  const [form] = Form.useForm();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const [profileModal, setProfileModal] = useState(false);
  const [profileModalType, setProfileModalType] = useState(""); //for opening different modals
  const MAX_FILE_SIZE = 25 * 1024 * 1024;
  const [isEditing, setIsEditing] = useState(false);
  const [editContact, setEditContact] = useState(false);
  const [editAddress, setEditAddress] = useState(false);
  const [changePasswordModal, setChangePasswordModal] = useState(false);
  const customLocale = {
    ...enUS,
    lang: {
      ...enUS.lang,
      shortWeekDays: ["S", "M", "T", "W", "T", "F", "S"],
    },
  };
  useEffect(() => {
    window.innerWidth <= 768
      ? setSelectedTab(null)
      : setSelectedTab("Personal Information");
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isMobile]);
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const tabParam = queryParams.get("tab");
  const [selectedTab, setSelectedTab] = useState(
    tabParam || "Personal Information",
  );
  const [selectedTabInMobile, setSelectedTabInMobile] = useState(
    tabParam || null,
  );
  const { user, userType, isLoading, requestStatus, variableChargeRates } =
    useSelector((state) => {
      const userProfile = state.userprofile;
      return {
        ...userProfile,
        userType:
          userProfile.userType === "basic" ? "Buyer" : userProfile.userType,
        isBasicUser: userProfile.userType === "basic",
      };
    });
  const userRole = useSelector((state) => state.login.userType);
  const profileTabs = [
    "Personal Information",
    "Account Information",
    "Privacy & Security",
    "Settings & Preferences",
    "Sub Seller Details",
    ...(userRole !== "basic" ? ["Variable Charge Rates"] : []),
    "Logout",
  ];
  const [showSubSeller, setShowSubSeller] = useState(
    user?.sub_seller_yes_no === 1,
  );
  const handleCallApi = async () => {
    try {
      dispatch(getUserProfile());
      dispatch(varibaleChargeRate());
    } catch (error) {
      if (error?.status === 401) {
        message.error(
          error?.message || "Something went wrong. Please try again.",
        );
      } else {
        message.error(
          error?.message || "Something went wrong. Please try again.",
        );
      }
    }
  };
  useEffect(() => {
    handleCallApi();
  }, []);
  const accountCreated =
    user?.created_at?.date &&
    format(new Date(user?.created_at.date), "MMMM d, yyyy");
  const lastLogin = user?.last_login?.date
    ? moment.utc(user?.last_login.date)
    : null;
  const getLastLogin = () => {
    if (!lastLogin) return null;
    const now = moment.utc();
    const minutesAgo = now.diff(lastLogin, "minutes");
    const hoursAgo = now.diff(lastLogin, "hours");
    const daysAgo = now.diff(lastLogin, "days");
    const monthsAgo = now.diff(lastLogin, "months");

    if (daysAgo === 0) {
      if (minutesAgo < 60) return `${minutesAgo} min ago`;
      return `${Math.floor(hoursAgo)} hr ${minutesAgo % 60} min ago`;
    }
    if (daysAgo === 1) return "Yesterday";
    if (daysAgo < 30) return `${daysAgo} days ago`;
    if (monthsAgo === 1) return "1 month ago";
    return `${monthsAgo} months ago`;
  };

  const handleSecurityAndSettings = (feildType, value) => {
    dispatch(
      postUserProfile({ mongo_id: user?.mongo_id, [feildType]: value }),
    ).then(() => {
      handleCallApi();
    });
  };

  const handleProfileModal = (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;

    if (selectedFile.size > MAX_FILE_SIZE) {
      message.error("File size must be less than 25MB!");
      return;
    }
    const reader = new FileReader();
    reader.readAsArrayBuffer(selectedFile);
    reader.onload = () => {
      setBinaryImage(new Blob([reader.result], { type: selectedFile.type }));
      setFile(selectedFile);
      setProfileModalType("editProfile");
      setProfileModal(true);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    };
    reader.onerror = () => {
      message.error("Error reading file. Please try again.");
    };
  };
  const handleCancelModal = () => {
    setProfileModal(false);
    setFile(null);
    setBinaryImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };
  const handleSaveAndApply = async () => {
    setProfileModal(false);
    try {
      const formData = new FormData();
      formData.append("mongo_id", user?.mongo_id);
      if (file) {
        formData.append("image[]", binaryImage, file?.name);
      }
      dispatch(postUserProfile(formData)).then(() => {
        handleCallApi()
          .then(() => {
            message.success("Profile Updated Successfully!");
          })
          .catch(() => {
            message.error("Error updating profile please try again!");
          });
      });
    } catch (error) {
      message.error("Error updating prfile please try agin");
    }
  };

  const getInitials = (firstName, lastName) => {
    const firstInitial = firstName?.charAt(0).toUpperCase() || "";
    const lastInitial = lastName?.charAt(0).toUpperCase() || "";
    return `${firstInitial}${lastInitial}`;
  };

  useEffect(() => {
    form.setFieldsValue({
      mongo_id: user?.mongo_id,
      first_name: user?.first_name,
      last_name: user?.last_name,
      date_of_birth: user?.date_of_birth ? dayjs(user?.date_of_birth) : null,
      email: user?.email,
      phone: user?.phone,
      address: user?.address,
      city: user?.city,
      state: user?.state,
      zipcode: user?.zipcode,
      country: user?.country,
      website: user?.website,
      two_factor_auth: user?.two_factor_auth ?? 0,
    });
  }, [form, user]);

  const handleSaveDetails = (values) => {
    dispatch(postUserProfile({ ...values, mongo_id: user?.mongo_id })).then(
      () => {
        handleCallApi();
      },
    );
  };

  const handleEdit = () => {
    setShowSubSeller(user?.sub_seller_yes_no === 1);

    form.setFieldsValue({
      sub_seller_name: user?.sub_seller_name || "",
      sub_seller_email: user?.sub_seller_email || "",
      sub_seller_phone: user?.sub_seller_phone || "",
    });

    setIsEditing(true);
  };
  const handleSellerDetailsSave = async (values) => {
    const payload = {
      address: user?.address || "",
      street: user?.street || "",
      city: user?.city || "",
      zipcode: user?.zipcode || "",
      website: user?.website || "",
      mongo_id: user?.mongo_id || "",

      first_name: user?.first_name || "",
      last_name: user?.last_name || "",
      name: user?.name || "",
      email: user?.email || "",
      phone: user?.phone || "",

      sub_seller_name: values?.sub_seller_name || "",
      sub_seller_email: values?.sub_seller_email || "",
      sub_seller_phone: values?.sub_seller_phone || "",
      sub_seller_yes_no: showSubSeller ? 1 : 0,
    };
    dispatch(postUserProfile(payload)).then((res) => {
      if (res?.payload?.status == 1) {
        message.success(res?.payload?.message);
      }
      handleCallApi();
    });
  };
  const renderContent = () => {
    return (
      <Form form={form} onFinish={handleSaveDetails}>
        {(selectedTab || selectedTabInMobile) === "Personal Information" && (
          <>
            <div className="personal-information-main-heading-div">
              <Text className="personal-information-main-heading main-title-size">
                {isMobile && (
                  <BackButton
                    size="small"
                    onClick={() => {
                      setSelectedTab(null);
                      setSelectedTabInMobile(null);
                    }}
                    className="back-button"
                  />
                )}
                Personal Information
              </Text>
              {!isMobile && (
                <span className="your-details-text">
                  Your Details, Your Identity
                </span>
              )}
            </div>
            <div className="upload-new-photo-card">
              <div className="upload-photo-content">
                <Row gutter={16} align={"middle"}>
                  <Col span={8} className="profile-image-section-remove">
                    {user?.image?.length > 0 ? (
                      <Image
                        src={`${API_BASE_URL_IMAGE}${user?.image[0]}`}
                        alt="Profile"
                        className="profile-image"
                        preview={false}
                      />
                    ) : (
                      <Avatar
                        size={64}
                        className="personal-details-avatar"
                        preview={false}
                      >
                        {getInitials(user?.first_name, user?.last_name)}
                      </Avatar>
                    )}
                    {user?.image && (
                      <Text
                        onClick={() => {
                          setProfileModalType("deleteProfile");
                          setProfileModal(true);
                        }}
                        className="profile-delete-text"
                      >
                        Remove Photo
                      </Text>
                    )}
                  </Col>
                  <Col span={16} className="sample-parent">
                    <div className="upload-profile-and-text">
                      <div className="parent-ant-button">
                        <span>{profileModal}</span>
                        <Button
                          icon={<UploadOutlined />}
                          className="profile-upload-btn"
                          onClick={() => fileInputRef.current?.click()}
                        >
                          <span className="upload-btn-text">
                            {" "}
                            Upload new Photo
                          </span>
                        </Button>
                      </div>
                      <input
                        type="file"
                        accept=".jpg, .jpeg,png"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleProfileModal}
                      />
                      <span className="upload-below-text">
                        Upload a new profile image (Max size: 25MB)
                      </span>
                    </div>
                  </Col>
                  <Modal
                    open={profileModal}
                    footer={null}
                    maskClosable={true}
                    closeIcon={false}
                    // centered
                  >
                    {profileModalType === "editProfile" && (
                      <div>
                        <Row className="profile-image-row">
                          <img
                            src={
                              file
                                ? URL.createObjectURL(file)
                                : user?.image
                                  ? user?.image
                                  : DefaulImage
                            }
                            alt="Profile"
                            className="profile-image"
                          />
                        </Row>
                        <Row className="profile-image-upload-buttons-row">
                          <Col>
                            <span>{profileModal}</span>
                            <Button
                              type="primary"
                              onClick={handleCancelModal}
                              className="billboard-button-1"
                            >
                              <span className="profile-upload-cancel-btn-text">
                                Cancel
                              </span>
                            </Button>
                          </Col>
                          <Col>
                            <Button
                              type="primary"
                              onClick={handleSaveAndApply}
                              className="profile-upload-save-btn"
                            >
                              <span className="profile-upload-save-btn-text">
                                Save and Apply
                              </span>
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    )}
                    {profileModalType === "deleteProfile" && (
                      <div className="delete-profile-container">
                        <Row>
                          <Text className="remove-profile-picture">
                            Remove Profile Picture?
                          </Text>
                        </Row>
                        <Row className="confirmation-remove-profile-row">
                          <Text className="confirmation-remove-profile-text">
                            Are you sure you want to remove your profile
                            picture? You can upload a new one anytime.
                          </Text>
                        </Row>
                        <Row className="remove-profile-buttons-row">
                          <Button
                            type="primary"
                            className="profile-delete-cancel-button"
                            onClick={() => setProfileModal(false)}
                          >
                            <Text className="profile-delete-cancel-button-text">
                              Cancel
                            </Text>
                          </Button>
                          <Button
                            type="primary"
                            className="remove-profile-button"
                            onClick={handleDeleteProfile}
                          >
                            <Text className="remove-profile-button-text">
                              Remove
                            </Text>
                          </Button>
                        </Row>
                      </div>
                    )}
                  </Modal>
                </Row>
              </div>
            </div>
            <div className="personal-details-card">
              <Row className="details-row-div">
                <Col>
                  <h3 className="card-tittle">Personal Details</h3>
                </Col>
                <Col>
                  {!isEditing && (
                    <Button
                      type="text"
                      icon={<EditOutlined />}
                      className="edit-button"
                      onClick={() => setIsEditing(true)}
                    >
                      Edit
                    </Button>
                  )}
                </Col>
              </Row>
              <Row className="details-row-div" style={{ width: "100%" }}>
                <Col className="details-label-col">
                  <span className="details-row-headers">First Name</span>
                </Col>
                <Col className="personal-details-col">
                  {isEditing ? (
                    <Form.Item name="first_name">
                      <FloatingInput name="first_name" />
                    </Form.Item>
                  ) : (
                    <span className="details-row-text">
                      {user?.first_name || "N/A"}
                    </span>
                  )}
                </Col>
              </Row>
              <Row className="details-row-div" style={{ width: "100%" }}>
                <Col className="details-label-col">
                  <span className="details-row-headers">Last Name</span>
                </Col>
                <Col className="personal-details-col">
                  {isEditing ? (
                    <Form.Item name="last_name">
                      <FloatingInput name="last_name" />
                    </Form.Item>
                  ) : (
                    <span className="details-row-text">
                      {user?.last_name || "N/A"}
                    </span>
                  )}
                </Col>
              </Row>
              <Row className="details-row-div" style={{ width: "100%" }}>
                <Col className="details-label-col">
                  <span className="details-row-headers">Date of Birth</span>
                </Col>
                <Col className="personal-details-col">
                  {isEditing ? (
                    <Form.Item name="date_of_birth">
                      <DatePicker
                        name="startDate"
                        locale={customLocale}
                        className="my-billboard-datepicker personal-details-datepicker"
                        placeholder="DOB"
                        suffixIcon={<CalenderIcon />}
                        onChange={(date, dateString) =>
                          dateString
                            ? form.setFieldValue({
                                date_of_birth: dayjs
                                  ?.utc(dateString, "YYYY-MM-DD")
                                  ?.startOf("day")
                                  ?.toISOString(),
                              })
                            : form.setFieldValue({
                                date_of_birth: "",
                              })
                        }
                        onKeyDown={(e) => {
                          if (
                            !/[0-9/]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        getPopupContainer={(trigger) => trigger.parentNode}
                        disabledDate={(current) => {
                          return current && current > dayjs().endOf("day");
                        }}
                      />
                    </Form.Item>
                  ) : (
                    <span className="details-row-text">
                      {user?.date_of_birth
                        ? dayjs(user?.date_of_birth).format("YYYY-MM-DD")
                        : "N/A"}
                    </span>
                  )}
                </Col>
              </Row>
              {isEditing && (
                <Row className="details-row-div">
                  <Col></Col>
                  <Col>
                    <Row gutter={[16, 16]}>
                      <Col span={12}>
                        <Button
                          type="primary"
                          className=" billboard-button-1"
                          onClick={() => setIsEditing(false)}
                        >
                          <span className="details-cancel-btn-text">
                            Cancel
                          </span>
                        </Button>
                      </Col>
                      <Col span={12}>
                        <Button
                          type="primary"
                          className="billboard-button-2"
                          onClick={() => {
                            form.submit();
                            setIsEditing(false);
                          }}
                        >
                          <span className="details-save-btn-text">Save</span>
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </div>
            <div className="contact-information-card">
              <Row className="details-row-div">
                <Col>
                  <h3 className="card-tittle">Contact Information</h3>
                </Col>
              </Row>
              <Row className="details-row-div" style={{ width: "100%" }}>
                <Col className="details-label-col">
                  <span className="details-row-headers">Email Address</span>
                </Col>
                <Col className="personal-details-col">
                  {editContact ? (
                    <Form.Item name="email">
                      <FloatingInput name="email" />
                    </Form.Item>
                  ) : (
                    <span className="details-row-text">
                      {user?.email || "N/A"}
                    </span>
                  )}
                </Col>
              </Row>
              <Row className="details-row-div" style={{ width: "100%" }}>
                <Col className="details-label-col">
                  <span className="details-row-headers">Phone Number</span>
                </Col>
                <Col className="personal-details-col">
                  {editContact ? (
                    <Form.Item name="phone">
                      <FloatingInput name="phone" />
                    </Form.Item>
                  ) : (
                    <span className="details-row-text">
                      {user?.phone || "N/A"}
                    </span>
                  )}
                </Col>
              </Row>
              {editContact && (
                <Row className="details-row-div">
                  <Col></Col>
                  <Col>
                    <Row gutter={[16, 16]}>
                      <Col span={12}>
                        <Button
                          type="primary"
                          className="billboard-button-1"
                          onClick={() => setEditContact(false)}
                        >
                          <span className="details-cancel-btn-text">
                            Cancel
                          </span>
                        </Button>
                      </Col>
                      <Col span={12}>
                        <Button
                          type="primary"
                          className="billboard-button-2"
                          onClick={() => {
                            form.submit();
                            setEditContact(false);
                          }}
                        >
                          <span className="details-save-btn-text">Save</span>
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </div>
            <div className="address-card">
              <Row className="details-row-div">
                <Col>
                  <h3 className="card-tittle">Address</h3>
                </Col>
                <Col>
                  {!editAddress && (
                    <Button
                      type="text"
                      icon={<EditOutlined />}
                      className="edit-button"
                      onClick={() => setEditAddress(true)}
                    >
                      Edit
                    </Button>
                  )}
                </Col>
              </Row>

              <Row className="details-row-div" style={{ width: "100%" }}>
                <Col className="details-label-col">
                  <span className="details-row-headers">Address</span>
                </Col>
                <Col className="personal-details-col">
                  {editAddress ? (
                    <Form.Item name="address">
                      <FloatingInput name="address" />
                    </Form.Item>
                  ) : (
                    <span className="details-row-text">
                      {user?.address || "N/A"}
                    </span>
                  )}
                </Col>
              </Row>

              <Row className="details-row-div" style={{ width: "100%" }}>
                <Col className="details-label-col">
                  <span className="details-row-headers">City</span>
                </Col>
                <Col className="personal-details-col">
                  {editAddress ? (
                    <Form.Item name="city">
                      <FloatingInput name="city" />
                    </Form.Item>
                  ) : (
                    <span className="details-row-text">
                      {user?.city || "N/A"}
                    </span>
                  )}
                </Col>
              </Row>

              <Row className="details-row-div" style={{ width: "100%" }}>
                <Col className="details-label-col">
                  <span className="details-row-headers">State/Province</span>
                </Col>
                <Col className="personal-details-col">
                  {editAddress ? (
                    <Form.Item name="state">
                      <FloatingInput name="state" />
                    </Form.Item>
                  ) : (
                    <span className="details-row-text">
                      {user?.state || "N/A"}
                    </span>
                  )}
                </Col>
              </Row>

              <Row className="details-row-div" style={{ width: "100%" }}>
                <Col className="details-label-col">
                  <span className="details-row-headers">ZIP/Postal Code</span>
                </Col>
                <Col className="personal-details-col">
                  {editAddress ? (
                    <Form.Item name="zipcode">
                      <FloatingInput
                        inputMode="decimal"
                        maxLength={10}
                        pattern="[0-9]*"
                        onKeyDown={(e) => {
                          if (["e", "E", "+", "-"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        name="zipcode"
                      />
                    </Form.Item>
                  ) : (
                    <span className="details-row-text">
                      {user?.zipcode || "N/A"}
                    </span>
                  )}
                </Col>
              </Row>

              <Row className="details-row-div" style={{ width: "100%" }}>
                <Col className="details-label-col">
                  <span className="details-row-headers">Country</span>
                </Col>
                <Col className="personal-details-col">
                  {editAddress ? (
                    <Form.Item name="country">
                      <FloatingInput name="country" />
                    </Form.Item>
                  ) : (
                    <span className="details-row-text">
                      {user?.country || "N/A"}
                    </span>
                  )}
                </Col>
              </Row>

              <Row className="details-row-div" style={{ width: "100%" }}>
                <Col className="details-label-col">
                  <span className="details-row-headers">Website</span>
                </Col>
                <Col className="personal-details-col">
                  {editAddress ? (
                    <Form.Item name="website">
                      <FloatingInput name="website" />
                    </Form.Item>
                  ) : (
                    <a
                      className={
                        user?.website ? "website-url" : "details-row-text"
                      }
                      href={user?.website || "#"}
                      target="_blank"
                      rel="noreferrer"
                      onClick={(e) => {
                        if (!user?.website) e.preventDefault();
                      }}
                    >
                      {user?.website || "N/A"}
                    </a>
                  )}
                </Col>
              </Row>

              {editAddress && (
                <Row className="details-row-div" style={{ width: "100%" }}>
                  <Col></Col>
                  <Col>
                    <Row gutter={[16, 16]}>
                      <Col span={12}>
                        <Button
                          type="primary"
                          className="billboard-button-1"
                          onClick={() => setEditAddress(false)}
                        >
                          <span className="details-cancel-btn-text">
                            Cancel
                          </span>
                        </Button>
                      </Col>
                      <Col span={12}>
                        <Button
                          type="primary"
                          className="billboard-button-2"
                          onClick={() => {
                            form.submit();
                            setEditAddress(false);
                          }}
                        >
                          Save
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </div>
          </>
        )}
        {(selectedTab || selectedTabInMobile) === "Account Information" && (
          <>
            <div className="personal-information-main-heading-div">
              <Text className="personal-information-main-heading">
                {isMobile && (
                  <BackButton
                    size="small"
                    onClick={() => {
                      setSelectedTab(null);
                      setSelectedTabInMobile(null);
                    }}
                    className="back-button"
                  />
                )}
                Account Information
              </Text>
              {!isMobile && (
                <span className="your-details-text">
                  Your Details, Your Identity
                </span>
              )}
            </div>
            <div className="account-information-card">
              <Row className="details-row-div">
                <Col>
                  <span className="account-row-headers">Account Type</span>
                </Col>
                <Col className="account-type-logo-col">
                  <Avatar
                    alt="account-type"
                    src={<AccountTypeIcon />}
                    style={{ marginRight: "5px" }}
                  />
                  <span className="details-row-text">{userType || "N/A"}</span>
                </Col>
              </Row>
            </div>
            <div className="membership-status-card">
              <Row className="details-row-div">
                <Col>
                  <h3 style={{ fontFamily: "Roboto" }}>Personal Details</h3>
                </Col>
                <Col></Col>
              </Row>
              <Row className="details-row-div" style={{ width: "100%" }}>
                <Col className="details-label-col">
                  <span className="details-row-headers">Account Created</span>
                </Col>
                <Col>
                  <span className="details-row-text">
                    {accountCreated || "N/A"}
                  </span>
                </Col>
              </Row>
              <Row className="details-row-div" style={{ width: "100%" }}>
                <Col className="details-label-col">
                  <span className="details-row-headers">Last Login</span>
                </Col>
                <Col>
                  {user?.last_login?.date && (
                    <span className="details-row-text">
                      {getLastLogin() || "N/A"}
                    </span>
                  )}
                </Col>
              </Row>
            </div>
            <div className="subscription-plan-card">
              <Row className="details-row-div">
                <Col>
                  <span className="subscription-plan-head">
                    Subscription Plan
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row className="details-row-div">
                <Col>
                  <span className="details-row-headers">Current Plan</span>
                </Col>
                <Col>
                  <span className="details-row-text">Basic</span>
                </Col>
              </Row>
              <Row className="details-row-div">
                <Col>
                  <span className="details-row-headers">Benefits</span>
                </Col>
                <Col>
                  <span className="details-row-text">
                    Access to Basic Media Library Create and Launch 1 Campaign
                    Basic Analytics Standard Support (Email) Limited
                    Customization
                  </span>
                </Col>
              </Row>
              <Row className="details-row-div">
                <Col>
                  <span className="details-row-headers">Next Billing Date</span>
                </Col>
                <Col>
                  <span className="details-row-text">-</span>
                </Col>
              </Row>
              <Row align="middle" justify="center">
                <div className="manage-subscription-link-container">
                  <Button type="link" className="manage-subscription-link">
                    Manage your subscription renewal settings here.
                  </Button>
                </div>
              </Row>
            </div>
          </>
        )}
        {(selectedTab || selectedTabInMobile) === "Privacy & Security" && (
          <>
            <div className="personal-information-main-heading-div">
              <Text className="personal-information-main-heading">
                {isMobile && (
                  <BackButton
                    size="small"
                    onClick={() => {
                      setSelectedTab(null);
                      setSelectedTabInMobile(null);
                    }}
                    className="back-button"
                  />
                )}
                Privacy & Security
              </Text>
              {!isMobile && (
                <span className="your-details-text">
                  Your Data, Your Control
                </span>
              )}
            </div>
            <div className="personal-details-card">
              <Row className="details-row-div">
                <Col>
                  <span className="security-settings-head">
                    Security Settings
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row className="details-row-div" style={{ width: "100%" }}>
                <Col>
                  <span className="details-row-headers">
                    Two-Factor Authentication (2FA)
                  </span>
                </Col>
                <Col>
                  <div className="swith-button">
                    {" "}
                    <Switch
                      checked={form.getFieldValue("two_factor_auth") === 1}
                      onChange={(checked) => {
                        const updatedValue = checked ? 1 : 0;
                        handleSecurityAndSettings(
                          "two_factor_auth",
                          updatedValue,
                        );
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <Row className="details-row-div">
                <Col>
                  <span className="details-row-headers">Change Password</span>
                </Col>
                <Col>
                  <div>
                    <Button
                      type="link"
                      className="manage-subscription-link"
                      onClick={() => {
                        setChangePasswordModal(true);
                      }}
                    >
                      Change Password
                    </Button>
                  </div>
                </Col>
              </Row>
              <Row className="details-row-div">
                <Col>
                  <span className="details-row-headers">Login Alerts</span>
                </Col>
                <Col>
                  <div className="swith-button">
                    {" "}
                    <Switch
                      disabled
                      checked={user?.login_alerts == 1}
                      onChange={(checked) => {
                        const updatedValue = checked ? 1 : 0;
                        handleSecurityAndSettings("login_alerts", updatedValue);
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </div>
            <div className="account-recovery-card">
              <Row className="details-row-div">
                <Col>
                  <span className="account-recovery-head">
                    Account Recovery
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row className="details-row-div">
                <Col>
                  <span className="details-row-headers">
                    Account Recovery Options
                  </span>
                </Col>
                <Col>
                  <div>
                    {" "}
                    <Radio.Group
                      value={user?.account_recovery}
                      onChange={(e) =>
                        handleSecurityAndSettings(
                          "account_recovery",
                          e.target.value,
                        )
                      }
                    >
                      <Radio value={0} style={{ fontFamily: "Roboto" }}>
                        Mobile Number
                      </Radio>
                      <Radio value={1} style={{ fontFamily: "Roboto" }}>
                        Email
                      </Radio>
                    </Radio.Group>
                  </div>
                </Col>
              </Row>
            </div>
          </>
        )}
        {(selectedTab || selectedTabInMobile) === "Settings & Preferences" && (
          <>
            <div className="personal-information-main-heading-div">
              <Text className="personal-information-main-heading">
                {isMobile && (
                  <BackButton
                    size="small"
                    onClick={() => {
                      setSelectedTab(null);
                      setSelectedTabInMobile(null);
                    }}
                    className="back-button"
                  />
                )}
                Settings & Preferences
              </Text>
              {!isMobile && (
                <span className="your-details-text">
                  Customize Your Experience
                </span>
              )}
            </div>
            <div className="notification-preference-card">
              <Row className="details-row-div">
                <Col>
                  <span className="settings-preference-head">
                    Notification Preferences
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row className="details-row-div" style={{ width: "100%" }}>
                <Col className="details-label-col">
                  <span className="details-row-headers">Stay Updated</span>
                </Col>
                <Col>
                  <div>
                    <Checkbox
                      style={{ fontFamily: "Roboto" }}
                      checked={user?.notify_pref_email === 1}
                      onChange={(e) => {
                        handleSecurityAndSettings(
                          "notify_pref_email",
                          e.target.checked ? 1 : 0,
                        );
                      }}
                    >
                      Email
                    </Checkbox>
                    <Checkbox
                      style={{ fontFamily: "Roboto" }}
                      checked={user?.notify_pref_sms === 1}
                      onChange={(e) => {
                        handleSecurityAndSettings(
                          "notify_pref_sms",
                          e.target.checked ? 1 : 0,
                        );
                      }}
                    >
                      SMS
                    </Checkbox>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="help-support-card">
              <Row className="details-row-div">
                <Col>
                  <span className="payment-methods-head">Help & Support</span>
                </Col>
                <Col></Col>
              </Row>
              <Row className="details-row-div" style={{ width: "100%" }}>
                <Col className="details-label-col">
                  <span className="details-row-headers">Get Assistance</span>
                </Col>
                <Col>
                  <div>
                    <Button
                      type="link"
                      onClick={() => {
                        navigate("/home", {
                          state: {
                            navigatedLink: "frequently-asked-questions",
                          },
                        });
                      }}
                    >
                      <span className="access-faq-btn-text">Access FAQs</span>
                    </Button>
                    <Button type="link">
                      <span
                        className="access-faq-btn-text"
                        onClick={() => navigate("/contact")}
                      >
                        Contact support
                      </span>
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          </>
        )}
        {(selectedTab || selectedTabInMobile) === "Sub Seller Details" && (
          <>
            <div className="personal-information-main-heading-div">
              {isMobile && (
                <Text className="personal-information-main-heading">
                  <BackButton
                    size="small"
                    onClick={() => {
                      setSelectedTab(null);
                      setSelectedTabInMobile(null);
                    }}
                    className="back-button"
                  />
                  Sub Seller Details
                </Text>
              )}
            </div>
            <div className="personal-details-card">
              <Row
                className="details-row-div"
                style={{ justifyContent: isMobile && "flex-end" }}
              >
                {!isMobile && (
                  <Col>
                    <h3 className="card-tittle">Sub Seller Details</h3>
                  </Col>
                )}
                <Col>
                  {!isEditing && (
                    <Button
                      type="text"
                      icon={<EditOutlined />}
                      className="edit-button"
                      onClick={handleEdit}
                    >
                      Edit
                    </Button>
                  )}
                </Col>
              </Row>
              <Row className="details-row-div" style={{ width: "100%" }}>
                <Col className="details-label-col">
                  <span className="details-row-headers">Name</span>
                </Col>
                <Col className="personal-details-col">
                  {isEditing ? (
                    <Form.Item
                      name="sub_seller_name"
                      rules={[
                        {
                          required: true,
                          message: "Please enter sub seller name",
                        },
                        {
                          min: 2,
                          message: "Name must be at least 2 characters",
                        },
                        {
                          pattern: /^[A-Za-z0-9\s-]+$/,
                          message: "Name contains invalid characters",
                        },
                      ]}
                    >
                      <FloatingInput name="sub_seller_name" />
                    </Form.Item>
                  ) : (
                    <span className="details-row-text">
                      {user?.sub_seller_name || "N/A"}
                    </span>
                  )}
                </Col>
              </Row>
              <Row className="details-row-div" style={{ width: "100%" }}>
                <Col className="details-label-col">
                  <span className="details-row-headers">Email</span>
                </Col>
                <Col className="personal-details-col">
                  {isEditing ? (
                    <Form.Item
                      name="sub_seller_email"
                      rules={[
                        {
                          required: true,
                          message: "Please enter sub seller email",
                        },
                        {
                          type: "email",
                          message: "Please enter a valid email address",
                        },
                      ]}
                    >
                      <FloatingInput name="sub_seller_email" />
                    </Form.Item>
                  ) : (
                    <span
                      className="details-row-text"
                      style={{ overflowWrap: "anywhere" }}
                    >
                      {user?.sub_seller_email || "N/A"}
                    </span>
                  )}
                </Col>
              </Row>
              <Row className="details-row-div" style={{ width: "100%" }}>
                <Col className="details-label-col">
                  <span className="details-row-headers">Phone</span>
                </Col>
                <Col className="personal-details-col">
                  {isEditing ? (
                    <Form.Item
                      name="sub_seller_phone"
                      rules={[
                        {
                          required: true,
                          message: "Please enter sub seller phone",
                        },
                        {
                          pattern: /^[0-9]{10}$/,
                          message:
                            "Phone number must contain exactly 10 digits",
                        },
                      ]}
                    >
                      <FloatingInput name="sub_seller_phone" />
                    </Form.Item>
                  ) : (
                    <span className="details-row-text">
                      {user?.sub_seller_phone || "N/A"}
                    </span>
                  )}
                </Col>
              </Row>
              <Row className="details-row-div" style={{ width: "100%" }}>
                <Col className="details-label-col">
                  <span className="details-row-headers">Show/Hide</span>
                </Col>

                <Col className="personal-details-col">
                  {isEditing ? (
                    <Checkbox
                      checked={showSubSeller}
                      onChange={(e) => setShowSubSeller(e.target.checked)}
                    ></Checkbox>
                  ) : (
                    <span className="details-row-text">
                      {user?.sub_seller_yes_no === 1 ? "Show" : "Hide"}
                    </span>
                  )}
                </Col>
              </Row>
              {isEditing && (
                <Row className="details-row-div">
                  <Col></Col>
                  <Col>
                    <Row gutter={[16, 16]}>
                      <Col span={12}>
                        <Button
                          type="primary"
                          className=" billboard-button-1"
                          onClick={() => setIsEditing(false)}
                        >
                          <span className="details-cancel-btn-text">
                            Cancel
                          </span>
                        </Button>
                      </Col>
                      <Col span={12}>
                        <Button
                          type="primary"
                          className="billboard-button-2"
                          onClick={() => {
                            // form.submit();
                            handleSellerDetailsSave(form.getFieldsValue());
                            setIsEditing(false);
                          }}
                        >
                          <span className="details-save-btn-text">Save</span>
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </div>
          </>
        )}
        {(selectedTab || selectedTabInMobile) === "Variable Charge Rates" && (
          <>
            <div className="personal-information-main-heading-div">
              {isMobile && (
                <Text className="personal-information-main-heading">
                  <BackButton
                    size="small"
                    onClick={() => {
                      setSelectedTab(null);
                      setSelectedTabInMobile(null);
                    }}
                    className="back-button"
                  />
                  Variable Charge Rates
                </Text>
              )}
            </div>
            <div className="personal-details-card">
              <Row
                className="details-row-div"
                style={{ justifyContent: isMobile && "flex-end" }}
              >
                {!isMobile && (
                  <Col>
                    <h3 className="card-tittle">Variable Charge Rates</h3>
                  </Col>
                )}
              </Row>
              <Row className="details-row-div" style={{ width: "100%" }}>
                {variableChargeRates?.map((item) => (
                  <div key={item.id} className="variable-charge-item">
                    <p className="variable_charge_rates">
                      {item.variable_charge_type}
                    </p>

                    <p className="variable_charge_rates">
                      {item.charge_percentage}%
                    </p>
                  </div>
                ))}
              </Row>
            </div>
          </>
        )}
      </Form>
    );
  };
  const handleDeleteProfile = () => {
    const payload = {
      mongo_id: user?.mongo_id,
    };
    if (!payload.mongo_id) {
      message.error("User ID not found.");
      return;
    }
    dispatch(deleteUserProfile(payload)).then((res) => {
      if (res?.payload?.status === 1) {
        message.success(
          res?.payload?.message || "Profile image deleted successfully.",
        );
        setProfileModal(false);
        handleCallApi();
      } else {
        message.error(
          res?.payload?.message || "Failed to delete profile image.",
        );
        setProfileModal(false);
      }
    });
  };
  useEffect(() => {
    const currentTab = new URLSearchParams(location?.search)?.get("tab");
    if (currentTab && currentTab !== selectedTab) {
      setSelectedTab(currentTab);
    }
  }, [location.search, selectedTab]);

  return (
    <>
      {isMobile && (
        <div className="personal-details-container-mobile">
          {!selectedTabInMobile ? (
            <div className="buyer-contents-menu-card">
              <div className="personal-details-title">
                <span className="main-title-size">Profile</span>
              </div>
              {profileTabs?.map((tab, index) => (
                <div
                  key={index}
                  className="buyer-contents-menu segment-sizes"
                  style={{
                    background: selectedTabInMobile === tab ? "#F5F5F5" : "",
                    borderLeft:
                      selectedTabInMobile === tab &&
                      "8px solid var(--Colors-Primary-500, #D2042D)",
                  }}
                  onClick={() => {
                    if (tab === "Logout") {
                      localStorage.removeItem("token");
                      message.success("You have successfully signed out!");
                      dispatch(logout());
                      dispatch(clearAllProductFilters());

                      localStorage.clear();
                      dispatch(RESET_USER());
                      navigate("/");
                    } else {
                      setSelectedTabInMobile(tab);
                      navigate(`?tab=${encodeURIComponent(tab)}`);
                    }
                  }}
                >
                  <span className="buyer-contents-menu-name">
                    {tab}
                    <RightArrow />
                  </span>
                </div>
              ))}
            </div>
          ) : (
            <div>{renderContent()}</div>
          )}
        </div>
      )}
      {!isMobile && (
        <div className="personal-details-container">
          {!isMobile && (
            <div className="personal-details-title">
              {userType === "owner" ? (
                <span>Seller Profile</span>
              ) : (
                <span>Buyer Profile</span>
              )}
            </div>
          )}
          <div>
            <Row className="buyer-contents-menu-card-row" gutter={16}>
              {!isMobile && (
                <Col span={6} className="buyer-contents-first-col">
                  <div className="buyer-contents-menu-card">
                    {profileTabs
                      ?.filter((tab) => isMobile || tab !== "Logout")
                      ?.map((tab, index) => (
                        <div
                          key={index}
                          className="buyer-contents-menu"
                          style={{
                            background: selectedTab === tab ? "#F5F5F5" : "",
                            borderLeft:
                              selectedTab === tab &&
                              "8px solid var(--Colors-Primary-500, #D2042D)",
                          }}
                          onClick={() => {
                            setSelectedTab(tab);
                            navigate(`?tab=${encodeURIComponent(tab)}`);
                          }}
                        >
                          <span className="buyer-contents-menu-name">
                            {tab}
                          </span>
                        </div>
                      ))}
                  </div>
                </Col>
              )}
              <Col span={isMobile ? 24 : 12} className="buyer-content-details">
                <div>
                  {renderContent()} {/* Dynamic Card Rendering */}
                </div>
              </Col>
              <Col span={7} className="avatar-col">
                <div className="floating-avatar">
                  <Avatar src={<Speaker />} />
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}
      <ChangePassword
        changePasswordModal={changePasswordModal}
        setChangePasswordModal={setChangePasswordModal}
      />
      {isLoading && requestStatus !== "changePassword" && (
        <>
          <Spin size="large" fullscreen />
        </>
      )}
    </>
  );
};
export default PersonalDetails;
